import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';

function PointOfInterestImage({ selectedPoint, pointOfInterests, data }) {
    // TODO: make sure the src works in production
    const imageSrc = useMemo(() => {
        const src = pointOfInterests.find(point => point.name === selectedPoint)?.image;
        if (src) return src;
        return '/uae.jpg';
    }, [selectedPoint, data]);
    return <img src={imageSrc} alt="selected-city" className="h-full w-full object-cover" />;
}
export default observer(PointOfInterestImage);
